import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import SocialLinks from './components/SocialLinks';
import LocationMap from './components/LocationMap';
import Footer from './components/Footer';
// Importar as imagens de fundo diretamente
import MobileBackground from './assets/images/Porterhouse-10.jpg';
import DesktopBackground from './assets/images/Porterhouse-39.jpg';

function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <div className="min-h-screen bg-black relative">
      {/* Fundo para dispositivos móveis */}
      {isMobile && (
        <div 
          className="absolute inset-0 z-0 opacity-80"
          style={{ 
            backgroundImage: `url(${MobileBackground})`, 
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            backgroundBlendMode: 'normal'
          }}
        ></div>
      )}
      
      {/* Fundo para desktop - usando Porterhouse-39.jpg */}
      {!isMobile && (
        <div 
          className="absolute inset-0 z-0 opacity-90"
          style={{ 
            backgroundImage: `url(${DesktopBackground})`, 
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            backgroundBlendMode: 'normal'
          }}
        ></div>
      )}
      
      {/* Gradiente de sobreposição para melhorar a legibilidade - z-index reduzido */}
      <div 
        className="absolute inset-0 z-5 fixed"
        style={{
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.65), rgba(0,0,0,0.55))',
          opacity: 0.9
        }}
      ></div>
      
      {/* Conteúdo principal - z-index aumentado */}
      <div className="py-8 px-4 relative z-20">
        <Header title="PorterHouse Carnes" />
        
        <div className="max-w-2xl mx-auto mb-10 text-center">
          <p 
            className="text-gold mb-6 text-contrast"
            style={{
              textShadow: "0 1px 3px rgba(0,0,0,1), 0 0 10px rgba(0,0,0,0.9), 0 0 20px rgba(0,0,0,0.7)",
              fontSize: "1.1rem",
              fontWeight: 600
            }}
          >
            Descubra o prazer da verdadeira experiência de carnes nobres. Faça seu pedido pelos nossos canais ou visite nossa loja!
          </p>
        </div>
        
        <SocialLinks />
        <LocationMap />
        <Footer />
      </div>
    </div>
  );
}

export default App;
